import __useRealTimeState from './useRealTimeState';
import __useEventListener from './useEventListener';
import __useOnBlur from './useOnBlur';
import { __ToFarsi, __ToEnglish, __Commafy } from './string';
import __useBP from './useBP';
import { __RestAPI } from './api';
import { __nextBrowser } from './nextBrowser';
import { __AppStorage } from './storage';
import __useAsyncClick from './useAsyncClick';
import { __CopyToClipboard } from './string';
import { __DateString, __TimeDifference } from './time';
import { __hexToRgb } from './color';
import __useThen from './useThen';
import { __useRouterState } from './useModalHistory';
import useAppNav__ from './appNav';
import __useLongPress from './useLongPress';
import __useCoarsePointer from './useCoarsePointer';

export { __useRealTimeState as useRealTimeState };
export { __useEventListener as useEventListener };
export { __useOnBlur as useOnBlur };
export { __ToFarsi as ToFarsi };
export { __ToEnglish as ToEnglish };
export { __useBP as useBP };
export { __RestAPI as RestAPI };
export { __nextBrowser as nextBrowser };
export { __AppStorage as AppStorage };
export { __useAsyncClick as useAsyncClick };
export { __CopyToClipboard as CopyToClipboard };
export { __DateString as DateString };
export { __hexToRgb as hexToRgb };
export { __useThen as useThen };
export { __TimeDifference as TimeDifference };
export { __Commafy as Commafy };
export { __useRouterState as useRouterState };
export { useAppNav__ as useAppNav };
export { __useLongPress as useLongPress };
export { __useCoarsePointer as useCoarsePointer };
export { UsePopstateBlocker as usePopstateBlocker } from './usePopstateBlocker';
export const isAppInstalled = () =>
    document?.referrer?.startsWith('android-app://') ||
    __AppStorage.applicationOS.get()?.length ||
    __AppStorage.applicationStore.get()?.length;
